module.exports = __webpack_public_path__ + "static/media/amber-3@3x.295ecb40.png";